import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../../config/NaeSSchema";

class ImportedFileModel extends Model {
  static reducer(action, ImportedFileModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.ImportedFile.schema:
        action.payload.forEach((payload) => {
          const dbData = ImportedFileModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          ImportedFileModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
ImportedFileModel.modelName = "ImportedFileModel";

ImportedFileModel.fields = {
  id: attr(),
};

export default ImportedFileModel;